import {alignSequences} from '../../../../utils/sierra';
import sleep from 'sleep-promise';

const QUERYAMOUNT = 20; // The server only has 4 cores, but choose 25 for speed up #seq > 1000

export default async function alignAllSequences(
  rawDataCollection, updateLoadingText) {
  let rawAlignments = [];
  const {rawSequences} = rawDataCollection;
  let partialAlignedSeqs;
  let {rawAlignmentsCacheKey} = rawDataCollection;

  const speciesList = rawSequences.map((rawSeq) => {
    return rawSeq.species;
  }).filter((s) => s);

  let species = 'HIV1';
  if (speciesList.length > 0) {
    species = speciesList[0];
  }

  // first align all sequences
  // TODO: ignore aligned Sequence? Because sequence can't be changed.
  // TODO: store aligned UUID in rawSequence objects.
  for (let i = 0; i < rawSequences.length; i += QUERYAMOUNT) {
    const current_batch = rawSequences.slice(i, i + QUERYAMOUNT)
    const sequences = current_batch.map(({uuid: header, sequence}) => {
        if (!sequence) {
          return null;
        } else {
          return {header, sequence};
        }
      }).filter((d) => (d));
    // console.log(current_batch);
    [partialAlignedSeqs, rawAlignmentsCacheKey] = (
      await alignSequences(sequences, species, rawAlignmentsCacheKey));
    rawAlignments = rawAlignments.concat(partialAlignedSeqs);
    const loadingText = `Aligned Sequence: ${rawAlignments.length}/${rawSequences.length}`;
    rawDataCollection.rawAlignments = rawAlignments;
    rawDataCollection.rawAlignmentsCacheKey = rawAlignmentsCacheKey;
    updateLoadingText({
      loadingText: loadingText,
    });

    await sleep(1000);
  }

  return rawDataCollection;
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/alignment/align-api.js